import {
  MUTATION_TYPES,
  SET_CLEAR_FILTERS,
  SET_REFERRAL_ACTION_TYPE,
  SET_REFERRAL_CURRENT_FILTERS,
  SET_REFERRAL_DETAILS,
  SET_REFERRAL_DETAILS_COLLAPSE,
  SET_REFERRAL_DETAILS_SERVICE_COLLAPSE,
  SET_REFERRAL_DISABLED_ADMISSION_STATUS_REASON,
  SET_REFERRAL_DISABLED_CENTER,
  SET_REFERRAL_DISABLED_MUNICIPALITY,
  SET_REFERRAL_DISABLED_SCHOOL,
  SET_REFERRAL_IS_ADVANCED_FILTER,
  SET_REFERRAL_NEW_BILLING_CENTER,
  SET_REFERRAL_RADIO_BTN_SELECTED,
  SET_REFERRAL_REJECTION_REASON,
  SET_REFERRAL_RESET_SELECTION,
  SET_REFERRAL_RESULTS,
  SET_REFERRAL_SEARCH_TEXT,
  SET_REFERRAL_SELECTED_ACADEMY_YEAR,
  SET_REFERRAL_SELECTED_ADMISSION_REFERRAL_TYPES,
  SET_REFERRAL_SELECTED_ADMISSION_STATUS,
  SET_REFERRAL_SELECTED_ADMISSION_STATUS_REASONS,
  SET_REFERRAL_SELECTED_CENTER,
  SET_REFERRAL_SELECTED_DISCIPLINE,
  SET_REFERRAL_SELECTED_FILTER,
  SET_REFERRAL_SELECTED_FILTER_TYPE,
  SET_REFERRAL_SELECTED_MUNICIPALITY,
  SET_REFERRAL_SELECTED_SCHOOL,
  SET_REFERRAL_SERVICE_CENTER,
  // eslint-disable-next-line prettier/prettier
  SET_REFERRAL_TABLE_CONFIG
} from './types';

const mutations = {
  [SET_REFERRAL_RESULTS](state, data) {
    const mappedResults = data.data.map((item) => ({
      ...item,
      currentDisciplineType: state.referral.filters.disciplines.find(e => e.id === item.disciplineTypeId)  || null,
      isDetailsOpened: false,
      disciplineTypeId: item.disciplineTypeId,
      details: null,
      showModifyAdmission: false,
      showAssign: false,
      currentCenter: {
        id: item.providerLinkCenterId,
        name: item.billingCenterName,
      },
    }));
    state.referral.results = mappedResults;

    state.referral.paging = {
      count: data.count,
      currentPage: data.currentPage,
      pageCount: data.pageCount,
      totalItemCount: data.totalItemCount,
      perPage: 15,
    };
  },
  [SET_REFERRAL_TABLE_CONFIG](state, data) {
    state.referral = {
      ...state.referral,
      paging: {
        ...state.paging,
        ...data,
      },
    };
  },
  [SET_REFERRAL_DETAILS](state, { admissionId, data }) {
    state.referral.results.map((item) => {
      item.isDetailsOpened = false;
      if (item.admissionId === admissionId) {
        item.details = {
          ...data,
          currentCenter: {
            id: data.billingCenterId,
            name: data.billingCenterName,
          },
        };
        item.isDetailsOpened = true;
      }
      return item;
    });
  },
  [SET_REFERRAL_DETAILS_COLLAPSE](state, { admissionId, isDetailsOpened }) {
    let item = state.referral.results.find(x => x.admissionId === admissionId)
    if (item) {
      item.isDetailsOpened = isDetailsOpened;
    }
    return item;
  },
  [SET_REFERRAL_DETAILS_SERVICE_COLLAPSE](state, { studentServiceId, isDetailsOpened }) {
    let item = state.referral.results.find(x => x.studentServiceId === studentServiceId)
    if (item) {
      item.isDetailsOpened = isDetailsOpened;
    }
    return item;
  },
  [SET_REFERRAL_CURRENT_FILTERS](state, currentFilters) {
    state.referral.currentFilters = currentFilters;
  },

  //collections
  //All Filters
  [MUTATION_TYPES.SET_REFERRAL_ACADEMY_YEAR](state, payload) {
    state.referral.filters.academicyears = payload;
  },

  // Standard Filter
  [MUTATION_TYPES.SET_REFERRAL_SCHOOL](state, payload) {
    state.referral.filters.schools = payload;
  },
  [MUTATION_TYPES.SET_SERVICE_MODALITY_TYPES](state, payload) {
    state.referral.filters.serviceModalityTypes = payload;
  },

  // Standard & Advanced Filters
  [MUTATION_TYPES.SET_REFERRAL_MUNICIPALITIES](state, payload) {
    state.referral.filters.municipalities = payload;
  },
  [MUTATION_TYPES.SET_REFERRAL_ADMISSION_STATUS_REASONS](state, payload) {
    state.referral.filters.admissionStatusReasons = payload;
  },
  [MUTATION_TYPES.SET_REFERRAL_ADMISSION_STATUS](state, payload) {
    state.referral.filters.admissionStatus = payload;
  },
  [MUTATION_TYPES.SET_REFERRAL_ADMISSION_REFERRAL_TYPES](state, payload) {
    state.referral.filters.admissionReferralTypes = payload;
  },

  //Standard & Waiting List Filters
  [MUTATION_TYPES.SET_REFERRAL_DISCIPLINE](state, payload) {
    state.referral.filters.disciplines = payload;
  },

  //Advanced Filters Mutation
  [MUTATION_TYPES.SET_REFERRAL_MONTHS](state, payload) {
    state.referral.filters.months = payload;
  },
  [MUTATION_TYPES.SET_REFERRAL_PROVIDERS](state, payload) {
    state.referral.filters.providers = payload;
  },
  [MUTATION_TYPES.SET_REFERRAL_LOCATIONS_SERVICES](state, payload) {
    state.referral.filters.locationServices = payload;
  },
  [MUTATION_TYPES.SET_REFERRAL_LOCATION_TYPES](state, payload) {
    state.referral.filters.locationTypes = payload;
  },
  [MUTATION_TYPES.SET_REFERRAL_SPECIALISTS](state, payload) {
    state.referral.filters.specialists = payload;
  },
  //Advanced & Waiting List Filters
  [MUTATION_TYPES.SET_REFERRAL_CENTERS](state, payload) {
    state.referral.filters.centers = payload;
  },

  //Set Selected Avanced Filters
  [MUTATION_TYPES.SET_CURRENT_FILTERS](state, payload) {
    state.referral.filters.currentFilters = payload;
  },
  //Set Admission Rejection History
  [MUTATION_TYPES.SET_ADMISSION_REJECTION_HISTORY](state, payload) {
    state.link.admissionrejectionhistory = payload;
  },
  //Selected [Deprecated?]
  [SET_REFERRAL_SELECTED_ACADEMY_YEAR](state, payload) {
    state.referral.filters.selectedAcademicYear = payload;
  },
  //Only for persisted the filters than already searched
  [MUTATION_TYPES.SET_SELECTED_ACADEMIC_YEAR_BY_FILTER](state, payload) {
    state.referral.filters.selectedAcademicYearByFilters = payload;
  },
  [SET_REFERRAL_SELECTED_DISCIPLINE](state, payload) {
    state.referral.filters.selectedDiscipline = payload;
  },
  [SET_REFERRAL_SELECTED_MUNICIPALITY](state, payload) {
    state.referral.filters.selectedMunicipality = payload;
  },
  [SET_REFERRAL_SELECTED_CENTER](state, payload) {
    state.referral.filters.selectedCenter = payload;
  },
  [SET_REFERRAL_SELECTED_SCHOOL](state, payload) {
    state.referral.filters.selectedSchool = payload;
  },
  [SET_REFERRAL_SELECTED_ADMISSION_STATUS](state, payload) {
    state.referral.filters.selectedAdmissionStatus = payload;
  },
  [SET_REFERRAL_SELECTED_ADMISSION_STATUS_REASONS](state, payload) {
    state.referral.filters.selectedAdmissionStatusReason = payload;
  },
  [SET_REFERRAL_SELECTED_ADMISSION_REFERRAL_TYPES](state, payload) {
    state.referral.filters.selectedAdmissionReferralType = payload;
  },

  //other
  [SET_REFERRAL_IS_ADVANCED_FILTER](state, payload) {
    state.referral.filters.isAdvancedFilter = payload;
  },
  [SET_REFERRAL_DISABLED_CENTER](state, payload) {
    state.referral.filters.disableCenter = payload;
  },
  [SET_REFERRAL_DISABLED_MUNICIPALITY](state, payload) {
    state.referral.filters.disableMunicipality = payload;
  },
  [SET_REFERRAL_DISABLED_SCHOOL](state, payload) {
    state.referral.filters.disableSchool = payload;
  },
  [SET_REFERRAL_DISABLED_ADMISSION_STATUS_REASON](state, payload) {
    state.referral.filters.disableAdmissionStatusReason = payload;
  },
  [SET_REFERRAL_SEARCH_TEXT](state, payload) {
    state.referral.filters.searchText = payload;
  },
  [SET_REFERRAL_SELECTED_FILTER](state, payload) {
    state.referral.filters.selectedFilter = payload;
  },
  [SET_REFERRAL_RADIO_BTN_SELECTED](state, payload) {
    state.referral.filters.radioBtnSelected = payload;
  },
  [SET_REFERRAL_SELECTED_FILTER_TYPE](state, payload) {
    state.referral.filters.selectedFilterType = payload;
  },
  [SET_REFERRAL_RESET_SELECTION](state) {
    state.referral.results = [];
    state.referral.currentFilters = null;
    state.referral.filters.isAdvancedFilter = false;
    state.referral.filters.selectedFilter = null;
    state.referral.filters.searchText = '';
    state.referral.filters.radioBtnSelected = null;
    state.referral.filters.selectedFilterType = 1;
    state.referral.paging = {
      perPage: 15,
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 0,
      count: 0,
    };
  },
  [SET_REFERRAL_SERVICE_CENTER](state, payload) {
    state.referral.serviceCenters = payload;
  },
  [SET_REFERRAL_NEW_BILLING_CENTER](state, { admissionId, data }) {
    state.referral.results.map((item) => {
      if (item.admissionId === admissionId) {
        item.details = {
          ...item.details,
          currentCenter: {
            id: data.newBillingCenterId,
            name: data.newBillingCenterName,
          },
        };
      }
      return item;
    });
  },
  setAdmissionSchool(state, payload) {
    state.link.providerSchools = payload;
  },
  setProviderReasons(state, payload) {
    state.link.providerReasons = payload;
  },
  setProviderDetail(state, payload) {
    state.link.providerDetail = payload;
  },
  setSchoolMunicipality(state, payload) {
    state.link.municipalitiesSchool = payload;
  },
  setHomeMunicipality(state, payload) {
    state.link.municipalitiesHome = payload;
  },
  setSchoolHomeMunicipalitySchool(state, payload) {
    state.link.municipalitiesHomeSchools = payload;
  },
  setFreeSelectionMunicipality(state, payload) {
    state.link.municipalitiesFreeSelection = payload;
  },
  setSchoolFreeSelectionMunicipalitySchool(state, payload) {
    state.link.municipalitiesFreeSelectionSchools = payload;
  },
  setLinkUpdateInfo(state, { admissionId, statusId, statusName }) {
    state.referral.results.map((item) => {
      if (item.admissionId === admissionId) {
        item.statusId = statusId;
        item.status = statusName;
      }
      return item;
    });
  },
  setLastFiltered(state, payload) {
    state.referral.filters.lastFiltered = { ...payload };
  },
  [SET_REFERRAL_ACTION_TYPE](state, { id, actionType }) {
    state.referral = {
      ...state.referral,
      results: state.referral.results.map((item) => {
        item.actionType = null;
        item.isDetailsOpened = false;
        if (item.studentServiceId === id) {
          item.actionType = actionType;
        }
        return item;
      }),
    };
    return state.referral;
  },
  [SET_REFERRAL_REJECTION_REASON](state, payload) {
    state.referral.rejectionReasons = payload;
  },
  [SET_CLEAR_FILTERS](state, payload) {
    state.referral = {
      ...state.referral,
      filters: {
        ...state.referral.filters,
        ...payload,
      },
    };
  },
};

export default mutations;
